import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LeaderboardSelectionTabs from "./LeaderboardSelectionTabs";
import MemberAcademicYearSelect from "../../member/MemberAcademicYearSelect";
import fullscreenIcon from "../../../images/icons/icon-fullscreen.svg";
import { LEADERBOARDS } from "../../../_config/LeaderboardConfig";
import { iconButtonOverlaySx } from "../../../styles/cyberTheme";
import {
    ALL_ACADEMIC_YEARS,
    formatAcademicYearRangeLabel,
} from "../../../helper/AcademicYearHelper";

const DASHBOARD_LEADERBOARDS = LEADERBOARDS.filter((lb) => !lb.onlyInFullLeaderboard);

const YEAR_OPTIONS = [ALL_ACADEMIC_YEARS, 2026, 2025];

// Configurable interval in milliseconds
const SWITCH_INTERVAL = 100000;

export default function RankingPanel() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedYear, setSelectedYear] = useState(ALL_ACADEMIC_YEARS);
    const navigate = useNavigate();

    const { component: CurrentLeaderboard, orgType: currentOrgType } =
        DASHBOARD_LEADERBOARDS[currentIndex];

    const handleFullScreen = () => {
        const { type, orgType } = DASHBOARD_LEADERBOARDS[currentIndex];
        const leaderboardCode = `${type}-${orgType}`;
        console.log(`Navigating to full screen leaderboard: ${leaderboardCode}`);
        navigate(`/leaderboards/${leaderboardCode}`, { state: { year: selectedYear } });
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % DASHBOARD_LEADERBOARDS.length);
        }, SWITCH_INTERVAL);
        return () => clearInterval(timer);
    }, []);

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            {/* Leaderboard content */}
            <Box sx={{ flex: 1, minHeight: 0, position: "relative" }}>
                <CurrentLeaderboard
                    refreshInterval={SWITCH_INTERVAL}
                    orgType={currentOrgType}
                    year={selectedYear}
                />
                <Box
                    sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        right: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <MemberAcademicYearSelect
                        value={selectedYear}
                        onChange={setSelectedYear}
                        years={YEAR_OPTIONS}
                        formatLabel={formatAcademicYearRangeLabel}
                        sx={{ minWidth: 120 }}
                    />
                    <IconButton
                        onClick={handleFullScreen}
                        sx={iconButtonOverlaySx}
                    >
                        <img src={fullscreenIcon} alt="Full Screen" width={18} height={18} />
                    </IconButton>
                </Box>
            </Box>

            <LeaderboardSelectionTabs
                leaderboards={DASHBOARD_LEADERBOARDS}
                currentIndex={currentIndex}
                onSelect={setCurrentIndex}
            />
        </Box>
    );
}
